import request from "../utils/request";

/**
 * 获取会议列表
 * @param: page
 *      : pre_page
 *      : play_status
 *      : area_id
 *      : depart_id
 *      : month
 *      : year
 *      : position
 */
export function getLiveList(params) {
  return request.get(`/meeting/lists`, { params });
}

/**
 * 获取会议首页12条数据
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getLiveIndexList(params) {
  return request.get(`/meeting/index`, { params });
}
/**
 * 热门会议
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getLiveHotsList(params) {
  return request.get(`/meeting/hot`, { params });
}
/*
 * 往期回顾搜索接口
 * */
export function getLiveListBack(params) {
  return request.get(`/meeting/playback`, { params });
}
/**
 * 获取直播详情
 * @pathVar: id 直播ID
 */
export function getLiveDetail(id) {
  return request.get(`/meeting/show/${id}`, {});
}

/**
 * 获取当前直播会场列表信息
 * @param: cid
 */
export function getLiveRoundList(params) {
  return request.get(`/meeting/place/lists`, { params });
}

/**
 * 获取直播场次详情
 * @pathVar: id 场次ID
 */
export function getLiveRoundDetail(id) {
  return request.get(`/meeting/place/show/${id}`, {});
}

/**
 * 直播分享
 * @pathVar: id 直播Id
 */
export function shareLiveFor(id) {
  return request.get(`/meeting/share/${id}`, {});
}
/**
 * 分享模板
 */
export function shareTemplate() {
  return request.get(`/meeting/shares`, {});
}

/**
 * 会议购买
 * @param id roundid
 */
export function buyMeeting(params) {
  return request.post(`/meeting/buy`, params);
}

/**
 * 支付整场会议
 * @param {*} params
 * @returns
 */
export function payMeeting(params) {
  return request.post(`/meeting/pay`, params);
}

/**
 * 会议场次购买
 * @param id roundid
 */
export function buyMeetingPlace(params) {
  return request.post(`/meeting/buyPlace`, params);
}

/**
 * 会场金币支付
 * @param {*} params
 * @returns
 */
export function payMeetingPlace(params) {
  return request.post(`/meeting/payPlace`, params);
}

/**
 * 会议密码输入
 * @pathVar id 直播id
 * @param password 密码
 */
export function enterLivePassword(id, params) {
  return request.post(`/meeting/play/${id}`, params);
}
/**
 * 直播会议介绍
 * @param {*} params
 */
export function getMeetingPlaceComponent(params) {
  return request.get(`/meeting/modules`, { params });
}
/**
 * 直播购买状态
 * @param {*} params id,type
 */
export function buyStatus(params) {
  return request.get(`/meeting/buy`, { params });
}

/**
 * 输入当前会场密码
 * @param {*} roundId 会场id
 * @param {*} params 密码
 * @returns
 */
export function enterRoundPwd(roundId, params) {
  return request.post(`/meeting/play/${roundId}`, params);
}

// 获取直播回放
export function getLiveRecords(params) {
  return request.get(`/meeting/video/lists`, { params });
}

// 相关视频
export function getRelatedVideos(params) {
    return request.get(`/doctor/videos`, { params });
}

// 代付会场
export function callToPayMeetingPlace(params) {
  return request.post(`/meeting/paymentPlace`, params);
}

// 代付会议
export function callToPayMeeting(params) {
  return request.post(`/meeting/payment`, params);
}

// 验证直播订单状态
export function validateLiveOrderStatus(params) {
  return request.get(`/meeting/order`, params);
}

// 验证签到状态
export function validSignStatus(params) {
  return request.get(`/meeting/place/sign`, { params });
}

// 直播签到
export function liveSignInAction(params) {
  return request.post(`/meeting/place/sign`, params);
}

// 获取视频播放信息
// 接口ID：27738225

export function getVideoViewInfo(params) {
  return request.get(`/meeting/video/view`, { params });
}

// 微信预约直播
export function setWxSubscription(params) {
  return request.post(`/wechat/subscription`, params);
}
// 直播视频日志次数记录接口
export function getVideoView(params) {
  return request.get(`/meeting/live/view`, { params });
}
// 直播模块图片列表
export function getPhotoModule(params) {
  return request.get(`/meeting/module_images`, { params });
}
